'use strict';

export const PAGE_PARAMS = {
  uid: _vd_bootstrap_settings['uid'],
  pid: _vd_bootstrap_settings['pid'],
  languageUid: _vd_bootstrap_settings['language_uid'],
};
